'use client';

import { LINK } from '@constants';
import type { useRouter } from 'next/navigation';

export const EmptyViewingMoneyModal = (
  point: number,
  router: ReturnType<typeof useRouter>,
  setAlertModal,
) => {
  if ((point || 0) === 0) {
    return setAlertModal({
      actionButtonText: '뷰업하러 가기',
      content: '뷰업하기에 참여하고\n적립금을 모아보세요!',
      hasCloseButton: false,
      onClickActionButton: () => router.push(LINK.VIEWING),
      onClickButton: () => router.push(LINK.VIEWING_MONEY),
      title: '보유한 포인트가 없어요.',
    });
  }
  return router.push(LINK.VIEWING_MONEY);
};
